import isBlank from '@im-frontend/utils/isBlank';

export function dateValidator(date?: Date | string) {
  if (isBlank(date) || date instanceof Date) {
    return null;
  }
  return 'Please enter a valid date';
}

export function requiredDateValidator(date?: Date | string) {
  if (date instanceof Date) {
    return null;
  }
  return 'Please enter a valid date';
}
